(function() {
    'use strict';

    angular.module('app')
        .constant('isTestMode', false)
        .constant('iAmNotRobot', true)
        .constant('apiUrl', {
            tsApi: '//hr.taishinholdings.com.tw/api/',
            ssoApi: '//hr.taishinholdings.com.tw/sso/api/',
            ctmsApi: '//hr.taishinholdings.com.tw/ap/ctms/',
            pafUrl:'//hr.taishinholdings.com.tw/hrapp/TSDG_PDF_Web/?pdf='
        });
})();